import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ListagemDeEmpresas, DetalheDeEmpresa } from '../pages/cadastros';
import { ListagemDeMensalidades } from '../pages/mensalidades';
import { ListagemDeDespesas, DetalheDespesaRecorrente } from '../pages/despesas';
import { useDrawerContext } from '../shared/contexts';

export const AppRoutes = () => {
  const { setDrawerOptions, setDrawerItemOptions } = useDrawerContext();

  useEffect(() => {
    setDrawerOptions([
      {
        label: 'Empresas',
        icon: 'business',
        path: '/empresas',
      },
      {
        label: 'Dashboard',
        icon: 'insights',
        path: '/mensalidades',
      },
      {
        label: 'Despesas',
        icon: 'trending_down',
        path: '/despesas',
      },
    ]);

    setDrawerItemOptions([]);
  }, []);

  return (
    <Routes>
      <Route path="/empresas" element={<ListagemDeEmpresas />} />
      <Route path="/empresas/:id" element={<DetalheDeEmpresa />} />

      <Route path="/mensalidades" element={<ListagemDeMensalidades />} />

      <Route path="/despesas" element={<ListagemDeDespesas />} />
      <Route path="/despesas/:idrecorrencia" element={<DetalheDespesaRecorrente />} />

      <Route path="/" element={<Navigate to="/empresas" replace />} />

      <Route path="*" element={<Navigate to="/empresas" replace />} />
    </Routes>
  );
};
